"use client";

import { ChevronRight, type LucideIcon } from "lucide-react";

import {
    SidebarGroup,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubButton,
    SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { Link, useLocation } from "react-router-dom";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./ui/collapsible";


export function AdminNavMain({
    items,
    disableHighlight,
}: {
    items: {
        name: string;
        url: string;
        icon: LucideIcon;
        isActive?: boolean;
        onClick?: () => void;
        items?: {
            name: string;
            url: string;
        }[];
    }[];
    disableHighlight?: boolean;
}) {
    const location = useLocation();
    const pathname = location.pathname;
    return (
        <SidebarGroup>
            {/* <SidebarGroupLabel>Projects</SidebarGroupLabel> */}
            <SidebarMenu>
                {items.map((item) =>
                    item.items ? (
                        <Collapsible
                            key={item.name}
                            asChild
                            defaultOpen={
                                pathname == "/" && item.url == "/connectors" ? true : pathname.includes(item.url)
                            }
                            className="group/collapsible"
                        >
                            <SidebarMenuItem>
                                <CollapsibleTrigger asChild>
                                    <Link to={item.url}>
                                        <SidebarMenuButton
                                            tooltip={item.name}
                                            isActive={
                                                disableHighlight
                                                    ? false
                                                    : pathname == "/" && item.url == "/connectors"
                                                      ? true
                                                      : pathname.includes(
                                                            item.url.split("/")[item.url.split("/").length - 1]
                                                        ) ||
                                                        pathname.includes(
                                                            item.url.split("/")[item.url.split("/").length - 2]
                                                        )
                                            }
                                        >
                                            {item.icon && <item.icon />}
                                            <span>{item.name}</span>
                                            <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                                        </SidebarMenuButton>
                                    </Link>
                                </CollapsibleTrigger>
                                <CollapsibleContent>
                                    <SidebarMenuSub>
                                        {item.items?.map((subItem) => (
                                            <SidebarMenuSubItem key={subItem.name}>
                                                <SidebarMenuSubButton
                                                    asChild
                                                    isActive={
                                                        disableHighlight
                                                            ? false
                                                            : pathname == "/" && subItem.url == "/connectors"
                                                              ? true
                                                              : pathname.includes(subItem.url)
                                                    }
                                                >
                                                    <Link to={subItem.url}>
                                                        <span>{subItem.name}</span>
                                                    </Link>
                                                </SidebarMenuSubButton>
                                            </SidebarMenuSubItem>
                                        ))}
                                    </SidebarMenuSub>
                                </CollapsibleContent>
                            </SidebarMenuItem>
                        </Collapsible>
                    ) : (
                        <SidebarMenuItem key={item.name}>
                            <SidebarMenuButton
                                asChild
                                tooltip={item.name}
                                isActive={
                                    disableHighlight
                                        ? false
                                        : pathname == "/" && item.url == "/connectors"
                                          ? true
                                          : pathname.includes(item.url)
                                }
                                onClick={item.onClick}
                            >
                                <Link to={item.url}>
                                    <item.icon />
                                    <span>{item.name}</span>
                                </Link>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    )
                )}
            </SidebarMenu>
        </SidebarGroup>
    );
}
